export default __webpack_public_path__ + "static/media/Autokritigallery_26.d8a7065e.JPG";